// eslint-disable-next-line import/no-default-export
export default {
  // This will be replaced with TrueNAS version during production build (see /debian/rules).
  release: '',
};
